<template>
  <div class="list-card">
    <div class="list-card-container">
      <div :class="['img-container', position]">
        <div :style="{ backgroundImage: `url(${src})` }" class="img" />
      </div>
      <div :class="['content', position]">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.list-card {
  @include setColor(--color-background1, background-color);

  @include respond-min("medium") {
    padding: rem(60px) rem(20px);
  }

  .list-card-container {
    padding: rem(20px) 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
  }

  .img-container {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 100%;
    overflow: hidden;

    @include respond-min("medium") {
      width: 46%;
      padding-bottom: 50%; /* IE 11 */
      padding-bottom: #{"min(50%, 540px)"};

      &.right {
        order: 1;
      }
    }

    .img {
      position: absolute;
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: cover;
      transform: scale(1);
      transition: 1000ms transform ease;
    }
  }

  .content {
    width: 100%;
    margin-top: rem(15px);

    @include respond-min("medium") {
      width: 46%;
      margin-top: 0;
    }
  }

  .title {
    margin-bottom: 0;
    @include respond-min("medium") {
      margin-bottom: rem(10px);
    }
  }
  .subtitle {
    @include setColor(--color-subtitle);
  }

  .description {
    margin-top: rem(20px);
    @include respond-min("medium") {
      margin-top: rem(30px);
    }
  }

  .button {
    margin-top: rem(16px);

    @include respond-min("medium") {
      margin-top: rem(44px);
    }
  }
}
</style>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    position: {
      type: String,
      validator: pos => {
        return ["left", "right"].indexOf(pos) !== -1;
      },
    },
  },
};
</script>
